export interface ITagsEditRequest  {
    RelationID: number;
    TagItemIDs: Array<number>;

}

export class TagsEditRequest  implements ITagsEditRequest {
    RelationID: number;
    TagItemIDs: Array<number>;



    public Mock(): TagsEditRequest {
        this.RelationID = 0;
        this.TagItemIDs = new Array<number>();

        return this;
    }
}


export interface IMemberTagsEditRequest extends ITagsEditRequest { }
export class MemberTagsEditRequest extends TagsEditRequest { }

export interface ILicenseTagsEditRequest extends ITagsEditRequest {}
export class LicenseTagsEditRequest extends TagsEditRequest { }

export interface ICreditCardTagsEditRequest extends ITagsEditRequest { }
export class CreditCardTagsEditRequest extends TagsEditRequest { }

export interface IGisCreditsTagsEditRequest extends ITagsEditRequest { }
export class GisCreditsTagsEditRequest extends TagsEditRequest { }
